import work from './work';

const farmer = {
	consume: { food: 1, water: 1 },
	resilience: { food: 0.5, water: 0.5 },
	craftsmanship: { craftsmanship: 1 },
	luck: { luck: 1 },
	charisma: { charisma: 1 },
	startBonus: { food: 100 },

	work: { [work.forage]: 1.5, [work.craft]: 1.5, [work.fabricate]: 1.5 },
};

export default farmer;
